import global from '../modules/global';
import tracking from '../lib/tracking';
import common from '../modules/common';
import lookup from '../modules/lookup';
import '../../vendor/jquery-select';
import '../../vendor/jquery.caret';
import '../../vendor/jquery.numericInput';

common();
lookup();

export default function() {
    $(function () {
        global();

        $('.distributor-image').on('error', function() {
            $(this).parents('.distributor-box').addClass('hide');
        });

        $('.distributor-link').on('click', function() {
            let distiName = $(this).attr('data-distri-name');
            tracking.ckEventUrl($(this).attr('data-url'));
            tracking.recordUserClick('Distributor Link', distiName, 'SRP_Landing');
        });
    });
}